<div *ngIf="teamMembers.length <= overflowLimit">
  <sc-avatar
    *ngFor="let participant of teamMembers; let i = index"
    [style.zIndex]="50 + i"
    [tooltip]="participant.displayName || participant.fullName || participant.email"
    [photoURL]="participant.photoURL">
  </sc-avatar>
</div>

<div *ngIf="teamMembers.length > overflowLimit">
  <sc-avatar
    *ngFor="let participant of teamMembers.slice(0, overflowLimit - 1); let i = index"
    [style.zIndex]="50 + i"
    [tooltip]="participant.displayName || participant.fullName || participant.email"
    [photoURL]="participant.photoURL">
  </sc-avatar>

  <div class="count" [style.zIndex]="50 + overflowLimit" [tooltip]="overflowParticipants">
    <span>+{{ teamMembers.length - overflowLimit + 1 }}</span>
  </div>
</div>
